import { Card, Stack, Text, CardHeader, CardBody, StackDivider, Heading, Box, FormControl, FormLabel,
     Input, IconButton, FormHelperText, InputGroup, InputRightElement, WrapItem, Button, 
     VStack, HStack, Divider, useColorModeValue } from '@chakra-ui/react'
import { LoginContainer } from '../styleComponents/LoginStyle';
import { useState, useEffect } from 'react';
import {AiOutlineEyeInvisible, AiOutlineEye, AiOutlineUser, AiOutlineLock} from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Axios from '../utils/httpClient';
import { removeToken, setToken } from '../utils/tokenStorge';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector(state => state);
    const [show, setShow] = useState(false); 
    const handleClick = () => setShow(!show);
    const [obj, setObj] = useState({
        username: "", 
        password: ""  
    });
    const [error, setError] = useState({
        username: false,
        password: false,
        common_e: ""
    });
    
    useEffect(()=>{
        // If user is already logged in, redirect to home
        if (user?.id) {
            navigate('/home');
        } else {
            removeToken();
        }
    }, [user, navigate])
    
    const handleChange = e => {
        setObj({...obj, [e.target.name]: e.target.value});
        setError({...error, [e.target.name]: false, common_e: ''});
    }
    
    const onSubmit = e => {
        e.preventDefault();
        dispatch({type: "SET_LOADING", payload: true});
        let t = true, err= {};
        if(!obj?.username){
            t = false;
            err={...err, username: true}
        }
        if(!obj?.password){
            t = false;
            err={...err, password: true}
        }
        if(t){
            Axios().post('api/v1/account/login/', obj)
            .then(res=>{
                setToken(res?.data?.tokens?.access??"");
                dispatch({type: "SET_USER", payload: res?.data?.user??{}});
                dispatch({type: "SET_LOADING", payload: false});
                navigate('/home');
            }).catch(e=>{ 
                const msg = e?.response?.data?.detail || "Tizimga kirib bo'lmadi. Login va parolni tekshirish.";
                setError({common_e: msg})
            }).finally(()=>{
                dispatch({type: "SET_LOADING", payload: false});
            })
        }else{
            dispatch({type: "SET_LOADING", payload: false});
            setError(err);
        }
    }

    const bgGradient = useColorModeValue(
        // 'linear(to-br, #667eea 0%, #764ba2 100%)',
        // 'linear(to-br, #2D3748 0%, #4A5568 100%)'
    );

    return(<>
    <LoginContainer>
        <Box
            position="relative"
            w="100%"
            h="100vh"
            bgGradient={bgGradient}
            display="flex"
            alignItems="center"
            justifyContent="center"
            _before={{
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
                opacity: 0.3
            }}
        >
            <Card 
                className="login_card"
                bg="white"
                borderRadius="20px"
                boxShadow="0 25px 50px rgba(0, 0, 0, 0.15)"
                border="1px solid rgba(255, 255, 255, 0.2)"
                backdropFilter="blur(10px)"
                position="relative"
                overflow="hidden"
                _before={{
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #667eea 0%, #764ba2 50%, #667eea 100%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 3s ease-in-out infinite'
                }}
            >
                <CardHeader pb={3}>
                    <VStack spacing={3}>
                        <Box
                            position="relative"
                            w="100px"
                            h="100px"
                            borderRadius="50%"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            _before={{
                                content: '""',
                                position: 'absolute',
                                inset: '4px',
                                borderRadius: '50%',
                                background: 'white',
                                zIndex: 1
                            }}
                        >
                            <img 
                                src='/logo.png' 
                                alt='logo'
                                style={{
                                    width: '100px',
                                    height: '100px',
                                    objectFit: 'contain',
                                    zIndex: 2,
                                    position: 'relative',
                                    marginBottom: '-8px'
                                }}
                            />
                        </Box>
                        <Heading 
                            size='lg' 
                            color="gray.800"
                            fontWeight="700"
                            letterSpacing="-0.5px"
                        >
                            KPI SYSTEM
                        </Heading>
                    </VStack>
                </CardHeader>

                <CardBody pt={0}>
                    <VStack spacing={6}>
                        <VStack spacing={3} w="100%">
                            <Heading 
                                size='md' 
                                color="gray.800"
                                fontWeight="600"
                                textAlign="center"
                            >
                                Kabinetga kirish
                            </Heading>
                            <Text  
                                color="gray.600" 
                                fontSize="sm"
                                textAlign="center"
                                lineHeight="1.5"
                            >
                                Kabinetga kirish uchun <Text as="span" fontWeight="600" color="blue.600">admin</Text> tomonidan berilgan login va parolni kiriting
                            </Text>
                        </VStack>

                        <Box w="100%">
                            <form onSubmit={onSubmit}>
                                <VStack spacing={4}>
                                    <FormControl isInvalid={error?.username}>
                                        <FormLabel 
                                            color="gray.700" 
                                            fontWeight="500"
                                            fontSize="sm"
                                            mb={2}
                                        >
                                            <HStack spacing={2}>
                                                <AiOutlineUser color="#667eea" />
                                                <Text>Login</Text>
                                            </HStack>
                                        </FormLabel>
                                        <Input 
                                            type='text' 
                                            placeholder="Loginni kiriting"
                                            name="username"
                                            value={obj?.username}
                                            onChange={handleChange}
                                            size="lg"
                                            borderRadius="12px"
                                            border="2px solid"
                                            borderColor="gray.200"
                                            _hover={{
                                                borderColor: "blue.300"
                                            }}
                                            _focus={{
                                                borderColor: "blue.500",
                                                boxShadow: "0 0 0 3px rgba(102, 126, 234, 0.1)"
                                            }}
                                            bg="gray.50"
                                        />
                                        {error?.username && (
                                            <FormHelperText color="red.500" fontSize="xs" mt={1}>
                                                Loginni kiriting.
                                            </FormHelperText>
                                        )}
                                    </FormControl>

                                    <FormControl isInvalid={error?.password || error?.common_e}>
                                        <FormLabel 
                                            color="gray.700" 
                                            fontWeight="500"
                                            fontSize="sm"
                                            mb={2}
                                        >
                                            <HStack spacing={2}>
                                                <AiOutlineLock color="#667eea" />
                                                <Text>Parol</Text>
                                            </HStack>
                                        </FormLabel>
                                        <InputGroup size="lg">
                                            <Input
                                                pr='4.5rem'
                                                type={show ? 'text' : 'password'}
                                                placeholder='Parolni kiriting'
                                                name="password"
                                                value={obj?.password}
                                                onChange={handleChange}
                                                borderRadius="12px"
                                                border="2px solid"
                                                borderColor="gray.200"
                                                _hover={{
                                                    borderColor: "blue.300"
                                                }}
                                                _focus={{
                                                    borderColor: "blue.500",
                                                    boxShadow: "0 0 0 3px rgba(102, 126, 234, 0.1)"
                                                }}
                                                bg="gray.50"
                                            />
                                            <InputRightElement width='4.5rem' top="50%" transform="translateY(-50%)">
                                                <IconButton
                                                    h='2rem'
                                                    size='sm'
                                                    onClick={handleClick}
                                                    variant='ghost'
                                                    colorScheme='blue'
                                                    aria-label='Show password'
                                                    icon={show ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                                                    _hover={{
                                                        bg: "blue.50"
                                                    }}
                                                />
                                            </InputRightElement>
                                        </InputGroup>
                                        {error?.password && (
                                            <FormHelperText color="red.500" fontSize="xs" mt={1}>
                                                Parolni kiriting.
                                            </FormHelperText>
                                        )}
                                        {error?.common_e && (
                                            <FormHelperText color="red.500" fontSize="xs" mt={1}>
                                                {error?.common_e}
                                            </FormHelperText>
                                        )}
                                    </FormControl>

                                    <Button 
                                        type='submit'
                                        size="lg"
                                        w="100%"
                                        bg="linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                        color="white"
                                        borderRadius="12px"
                                        fontWeight="600"
                                        fontSize="md"
                                        py={6}
                                        _hover={{
                                            transform: "translateY(-2px)",
                                            boxShadow: "0 10px 25px rgba(102, 126, 234, 0.3)"
                                        }}
                                        _active={{
                                            transform: "translateY(0px)"
                                        }}
                                        transition="all 0.2s ease"
                                    >
                                        Kirish
                                    </Button>
                                </VStack>
                            </form>
                        </Box>
                    </VStack>
                </CardBody>
            </Card>
        </Box>
    </LoginContainer>
    </>);
}
export default Login;